import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-unii-number',
  templateUrl: './unii-number.component.html',
  styleUrls: ['./unii-number.component.scss']
})
export class UniiNumberComponent implements OnInit {
  @ViewChild('uniiNumberInput') uniiNumberInput!: ElementRef;
  uniiNumber!: string;

  constructor(private formService: FormService) {}
  
  ngOnInit(): void {
    this.uniiNumber = this.currentForm.get('uniiNumberforSingleEntity')?.value;
  }

  public clearUniiNumberInputField() {
    this.uniiNumber = '';
    this.currentForm.patchValue({'uniiNumberforSingleEntity': ''});
    this.errorCheck();
  }
  public updateUniiNumber(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.uniiNumber = '';
      }
    }
    this.currentForm.patchValue({'uniiNumberforSingleEntity': this.uniiNumber});
    this.errorCheck();
  }

  public cancelUpdate() {
    this.uniiNumber = this.currentForm.get('uniiNumberforSingleEntity')?.value;
    this.errorCheck();
  }

  private errorCheck() {
    const targetControl = this.currentForm.get('uniiNumberforSingleEntity');
    if(!targetControl) {
      return;
    }

    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }

}
